import { writable } from 'svelte/store';
export const notif = writable(0); 
export const session = writable(0);


 